var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"20px","margin":"0"}},[_c('input',{ref:"rng",attrs:{"type":"range","step":"1","min":"50","max":"500"},on:{"change":_vm.setDpi}})])}
var staticRenderFns = []

export { render, staticRenderFns }